import { useEffect, useState } from 'react';

export const MOBILE_VIEWPORT_MQL = '(max-width: 768px)';

/**
 * Shell drawer mode — must stay in sync with Sidebar / AuthenticatedAppShell
 * (`min-width: 1024px` = persistent sidebar). Tablets (769–1023) use the drawer.
 */
export const DRAWER_SIDEBAR_MQL = '(max-width: 1023px)';
export const DESKTOP_SIDEBAR_MQL = '(min-width: 1024px)';

/** True when viewport is at or below the standard mobile breakpoint (768px). */
export function useMobileViewport(): boolean {
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== 'undefined'
      ? window.matchMedia(MOBILE_VIEWPORT_MQL).matches
      : false,
  );

  useEffect(() => {
    const mql = window.matchMedia(MOBILE_VIEWPORT_MQL);
    const onChange = () => setIsMobile(mql.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, []);

  return isMobile;
}

/** True when the app shell uses an off-canvas sidebar (phone + tablet). */
export function useDrawerSidebarViewport(): boolean {
  const [isDrawer, setIsDrawer] = useState(() =>
    typeof window !== 'undefined'
      ? window.matchMedia(DRAWER_SIDEBAR_MQL).matches
      : false,
  );

  useEffect(() => {
    const mql = window.matchMedia(DRAWER_SIDEBAR_MQL);
    const onChange = () => setIsDrawer(mql.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, []);

  return isDrawer;
}
